// ------------------------------
// Contact + Collections: hide Footer CTA
// ------------------------------
(function () {
  var path = window.location.pathname.replace(/\/+$/, ""); // strip trailing slash

  var isContact = path === "/contact" || path === "/pages/contact";

  // Hide on ALL collection pages:
  var isCollections = path === "/collections" || path.indexOf("/collections/") === 0;

  // Hide on ALL product pages:
  var isProduct = path === "/products" || path.indexOf("/products/") === 0;

  // If it's not a page we care about, bail out
  if (!(isContact || isCollections || isProduct)) return;

  var targetSelector = "#shopify-section-sections--20442309427415__blocks_z7t6ML";
  var observer;

  function hideSection() {
    var el = document.querySelector(targetSelector);
    if (!el) return;
    el.style.display = "none";
    el.setAttribute("aria-hidden", "true");
    if (observer) observer.disconnect();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", hideSection, { once: true });
  } else {
    hideSection();
  }

  // In case Shopify injects the section after load
  observer = new MutationObserver(hideSection);
  observer.observe(document.body, { childList: true, subtree: true });
})();

// ----------------------------------------------------------------------------
// ----------------------------------------------------------------------------
// --- Reduce image width in Elfsight Event Calendar popup ---
// ----------------------------------------------------------------------------
// ----------------------------------------------------------------------------
(function () {
  const SEL_IMG = ".eapp-events-calendar-popup-item-media";

  function apply(img) {
    if (!img) return;
    // Use width + !important to override widget styles
    img.style.setProperty("background-color", "#ececec", "important");
    img.style.setProperty("border-radius", "1.75rem", "important");
    img.style.setProperty("padding", "2rem 2rem", "important");
    img.style.setProperty("margin", "0 auto", "important");
    img.style.setProperty("margin-top", "2rem", "important");
  }

  function scanExisting() {
    document.querySelectorAll(SEL_IMG).forEach(apply);
  }

  const observer = new MutationObserver((muts) => {
    for (const m of muts) {
      for (const n of m.addedNodes) {
        if (n.nodeType !== 1) continue; // elements only
        if (n.matches?.(SEL_IMG)) apply(n);
        n.querySelectorAll?.(SEL_IMG).forEach(apply);
      }
    }
  });

  function start() {
    const target = document.body;
    if (!target) {
      setTimeout(start, 50);
      return;
    }
    scanExisting();
    observer.observe(target, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();

// ----------------------------------------------------------------------------
// ----------------------------------------------------------------------------
// --- Change text styles in upcoming events popup ---
// ----------------------------------------------------------------------------
// ----------------------------------------------------------------------------
(function () {
  const SEL_TEXT = ".eapp-events-calendar-popup-item-category";

  function apply(img) {
    if (!img) return;
    // Use width + !important to override widget styles
    img.style.setProperty("font-weight", "600", "important");
  }

  function scanExisting() {
    document.querySelectorAll(SEL_TEXT).forEach(apply);
  }

  const observer = new MutationObserver((muts) => {
    for (const m of muts) {
      for (const n of m.addedNodes) {
        if (n.nodeType !== 1) continue; // elements only
        if (n.matches?.(SEL_TEXT)) apply(n);
        n.querySelectorAll?.(SEL_TEXT).forEach(apply);
      }
    }
  });

  function start() {
    const target = document.body;
    if (!target) {
      setTimeout(start, 50);
      return;
    }
    scanExisting();
    observer.observe(target, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();

// ----------------------------------------------------------------------------
// ----------------------------------------------------------------------------
// --- Change button styles in upcoming events popup ---
// ----------------------------------------------------------------------------
// ----------------------------------------------------------------------------
(function () {
  const SEL_BTN = ".eapp-events-calendar-popup-item-inner .eapp-events-calendar-share-link-button";

  function apply(img) {
    if (!img) return;
    // Use width + !important to override widget styles
    img.style.setProperty("border-radius", "100px", "important");
    img.style.setProperty("background-color", "#07c231", "important");
    img.style.setProperty("border", "0", "important");
  }

  function scanExisting() {
    document.querySelectorAll(SEL_BTN).forEach(apply);
  }

  const observer = new MutationObserver((muts) => {
    for (const m of muts) {
      for (const n of m.addedNodes) {
        if (n.nodeType !== 1) continue; // elements only
        if (n.matches?.(SEL_BTN)) apply(n);
        n.querySelectorAll?.(SEL_BTN).forEach(apply);
      }
    }
  });

  function start() {
    const target = document.body;
    if (!target) {
      setTimeout(start, 50);
      return;
    }
    scanExisting();
    observer.observe(target, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();

// ----------------------------------------------------------------------------
// ----------------------------------------------------------------------------
// --- Change button styles in upcoming events popup ---
// ----------------------------------------------------------------------------
// ----------------------------------------------------------------------------
(function () {
  const SEL_BTNS = ".eapp-events-calendar-popup-item-inner .eapp-events-calendar-share-email-button";

  function apply(img) {
    if (!img) return;
    // Use width + !important to override widget styles
    img.style.setProperty("border-radius", "100px", "important");
    img.style.setProperty("background-color", "#07c231", "important");
    img.style.setProperty("border", "0", "important");
  }

  function scanExisting() {
    document.querySelectorAll(SEL_BTNS).forEach(apply);
  }

  const observer = new MutationObserver((muts) => {
    for (const m of muts) {
      for (const n of m.addedNodes) {
        if (n.nodeType !== 1) continue; // elements only
        if (n.matches?.(SEL_BTNS)) apply(n);
        n.querySelectorAll?.(SEL_BTNS).forEach(apply);
      }
    }
  });

  function start() {
    const target = document.body;
    if (!target) {
      setTimeout(start, 50);
      return;
    }
    scanExisting();
    observer.observe(target, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();

// ----------------------------------------------------------------------------
// ----------------------------------------------------------------------------
// --- Change pop up container styles in upcoming events popup ---
// ----------------------------------------------------------------------------
// ----------------------------------------------------------------------------
(function () {
  const SEL_BTNS = ".eapp-events-calendar-popup-item-inner";

  function apply(img) {
    if (!img) return;
    // Use width + !important to override widget styles
    img.style.setProperty("border-radius", "28px", "important");
  }

  function scanExisting() {
    document.querySelectorAll(SEL_BTNS).forEach(apply);
  }

  const observer = new MutationObserver((muts) => {
    for (const m of muts) {
      for (const n of m.addedNodes) {
        if (n.nodeType !== 1) continue; // elements only
        if (n.matches?.(SEL_BTNS)) apply(n);
        n.querySelectorAll?.(SEL_BTNS).forEach(apply);
      }
    }
  });

  function start() {
    const target = document.body;
    if (!target) {
      setTimeout(start, 50);
      return;
    }
    scanExisting();
    observer.observe(target, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();

// ----------------------------------------------------------------------------
// ----------------------------------------------------------------------------
// --- Change button svg and text styles in upcoming events popup ---
// ----------------------------------------------------------------------------
// ----------------------------------------------------------------------------
(function () {
  const SEL_BTN_INNER = ".eapp-events-calendar-popup-item-inner .eapp-events-calendar-share-link-button svg path";

  function apply(img) {
    if (!img) return;
    // Use width + !important to override widget styles
    img.style.setProperty("fill", "#fff", "important");
  }

  function scanExisting() {
    document.querySelectorAll(SEL_BTN_INNER).forEach(apply);
  }

  const observer = new MutationObserver((muts) => {
    for (const m of muts) {
      for (const n of m.addedNodes) {
        if (n.nodeType !== 1) continue; // elements only
        if (n.matches?.(SEL_BTN_INNER)) apply(n);
        n.querySelectorAll?.(SEL_BTN_INNER).forEach(apply);
      }
    }
  });

  function start() {
    const target = document.body;
    if (!target) {
      setTimeout(start, 50);
      return;
    }
    scanExisting();
    observer.observe(target, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();

// ----------------------------------------------------------------------------
// ----------------------------------------------------------------------------
// --- Change button svg and text styles in upcoming events popup ---
// ----------------------------------------------------------------------------
// ----------------------------------------------------------------------------
(function () {
  const SEL_BTNS_INNER = ".eapp-events-calendar-popup-item-inner .eapp-events-calendar-share-email-button svg path";

  function apply(img) {
    if (!img) return;
    // Use width + !important to override widget styles
    img.style.setProperty("fill", "#fff", "important");
  }

  function scanExisting() {
    document.querySelectorAll(SEL_BTNS_INNER).forEach(apply);
  }

  const observer = new MutationObserver((muts) => {
    for (const m of muts) {
      for (const n of m.addedNodes) {
        if (n.nodeType !== 1) continue; // elements only
        if (n.matches?.(SEL_BTNS_INNER)) apply(n);
        n.querySelectorAll?.(SEL_BTNS_INNER).forEach(apply);
      }
    }
  });

  function start() {
    const target = document.body;
    if (!target) {
      setTimeout(start, 50);
      return;
    }
    scanExisting();
    observer.observe(target, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();

// ----------------------------------------------------------------------------
// ----------------------------------------------------------------------------
// --- Change button svg and text styles in upcoming events popup ---
// ----------------------------------------------------------------------------
// ----------------------------------------------------------------------------
(function () {
  const SEL_BTN_INNER_TEXT = ".eapp-events-calendar-popup-item-inner .eapp-events-calendar-share-link-button .eapp-events-calendar-share-link-text";

  function apply(img) {
    if (!img) return;
    // Use width + !important to override widget styles
    img.style.setProperty("color", "#fff", "important");
    img.style.setProperty("font-weight", "600", "important");
  }

  function scanExisting() {
    document.querySelectorAll(SEL_BTN_INNER_TEXT).forEach(apply);
  }

  const observer = new MutationObserver((muts) => {
    for (const m of muts) {
      for (const n of m.addedNodes) {
        if (n.nodeType !== 1) continue; // elements only
        if (n.matches?.(SEL_BTN_INNER_TEXT)) apply(n);
        n.querySelectorAll?.(SEL_BTN_INNER_TEXT).forEach(apply);
      }
    }
  });

  function start() {
    const target = document.body;
    if (!target) {
      setTimeout(start, 50);
      return;
    }
    scanExisting();
    observer.observe(target, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();

// ----------------------------------------------------------------------------
// ----------------------------------------------------------------------------
// --- Change button svg and text styles in upcoming events popup ---
// ----------------------------------------------------------------------------
// ----------------------------------------------------------------------------
(function () {
  const SEL_BTNS_INNER_TEXT = ".eapp-events-calendar-popup-item-inner .eapp-events-calendar-share-email-button .eapp-events-calendar-share-email-text";

  function apply(img) {
    if (!img) return;
    // Use width + !important to override widget styles
    img.style.setProperty("color", "#fff", "important");
    img.style.setProperty("font-weight", "600", "important");
  }

  function scanExisting() {
    document.querySelectorAll(SEL_BTNS_INNER_TEXT).forEach(apply);
  }

  const observer = new MutationObserver((muts) => {
    for (const m of muts) {
      for (const n of m.addedNodes) {
        if (n.nodeType !== 1) continue; // elements only
        if (n.matches?.(SEL_BTNS_INNER_TEXT)) apply(n);
        n.querySelectorAll?.(SEL_BTNS_INNER_TEXT).forEach(apply);
      }
    }
  });

  function start() {
    const target = document.body;
    if (!target) {
      setTimeout(start, 50);
      return;
    }
    scanExisting();
    observer.observe(target, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();
